import type { RouteObject } from 'react-router';
import { LazyComponent } from 'components/lazyComponent';

const ListPage = LazyComponent(() => import('./list'));
const CreatePage = LazyComponent(() => import('./create'));
const EditPage = LazyComponent(() => import('./edit'));

const routes: RouteObject[] = [{
  path: '/secrets',
  children: [
    { index: true, element: <ListPage /> },
    { path: 'create', element: <CreatePage /> },
    { path: 'edit/:key', element: <EditPage /> },
  ],
}];

export default routes;
